import React, { useCallback, useEffect, useState } from 'react';
import { useSelector } from 'react-redux';

import { Dialog, IconButton } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';

import '../../../assets/style/styleModalList.css';

import { InvoiceList } from './InvoiceList';
import { Model } from '../../../models/model';
import NumberFormat from 'react-number-format';

export const ModalListaFacturas = ({ title, open, setOpen, origen }) => {

    const {
        id: pptoId,
        simbolo,
        separacion_miles,
        separacion_decimales
    } = useSelector(state => state.ppto.detail)

    const [invoicesList, setInvoicesList] = useState([])
    const [filteredList, setFilteredList] = useState([])
    const [totales, setTotales] = useState({})

    const iniCargarInvoices = useCallback(async () => {
        try {

            const params = {
                url: `invoices/by-pptos/all/${pptoId}`,
            }

            const dataList = await Model.getAll(params)
            // console.log(dataList)

            setInvoicesList(dataList?.invoices || [])
            setTotales(dataList?.totales || {})

        } catch (error) {
            console.log(error)
        }

    }, [pptoId])

    const filterList = useCallback(async ({ target }) => {
        const { value } = target

        if (value === 'todas-no-nulas') {
            const filtered = invoicesList.filter(it => it.estado !== 'anulada')
            setFilteredList(filtered)
        }

        if (value === 'todas') {
            setFilteredList(invoicesList)
        }

        if (value !== 'todas-no-nulas' && value !== 'todas') {
            const filtered = invoicesList.filter(it => it.estado === value)
            setFilteredList(filtered)
        }

    }, [invoicesList])

    useEffect(() => {
        iniCargarInvoices();
    }, [iniCargarInvoices])

    useEffect(() => {
        filterList({
            target: { value: 'todas-no-nulas' }
        })
    }, [invoicesList, filterList])

    return (
        <Dialog
            open={open}
            onClose={() => setOpen(false)}
            aria-labelledby="simple-dialog-title"
            fullScreen={true}
        >
            <div className='ContainerDialogs'>

                <h1 className='TitleModalPresupuesto'>
                    <IconButton
                        style={{ padding: '0', float: 'right' }}
                        aria-label="close"
                        onClick={() => setOpen(false)}
                    >
                        <CloseIcon />
                    </IconButton>
                    {title}
                </h1>

                {invoicesList.length > 0 &&
                    <>
                        <div className='d-flex justify-content-start' style={{ color: 'gray' }}>
                            <div>{(invoicesList.filter(it => it.estado === 'por emitir')).length}{' '}por emitir</div>,
                            <div className='ms-2'>{(invoicesList.filter(it => it.estado === 'emitida')).length}{' '}emitidas</div>,
                            <div className='ms-2'>{(invoicesList.filter(it => it.estado === 'pagada')).length}{' '}pagadas</div>,
                            <div className='ms-2'>{(invoicesList.filter(it => it.estado === 'anulada')).length}{' '}anuladas</div>
                        </div>
                        <select name="filter" className='mt-3 ms-2' onChange={filterList} style={{ color: 'gray', boder: '1px solid red' }}>
                            <option selected value="todas-no-nulas" style={{ color: 'gray' }}>Menos anuladas</option>
                            <option value="por emitir">Por emitir</option>
                            <option value="emitida">Emitidas</option>
                            <option value="cobradas">Cobradas</option>
                            <option value="anulada">Anuladas</option>
                            <option value="todas">Todas</option>
                        </select>
                    </>
                }

                <div className='text-end me-2'>

                    <div className='m'>
                        <label className='ms-2' style={{ color: '#8e24aa', fontSize: '16px' }}>Monto Base: </label>
                        <span className='ms-2' style={{ color: '#78717A', fontSize: '15px', fontWeight: 'bold' }}>
                            <NumberFormat
                                value={parseFloat(totales.totalFacturadoNeto) || 0}
                                displayType={'text'}
                                thousandSeparator={separacion_miles}
                                decimalSeparator={separacion_decimales}
                                prefix={`${simbolo} `}
                                decimalScale={2}
                                fixedDecimalScale
                            />
                        </span>
                    </div>

                    <div className=''>
                        <label className='ms-2' style={{ color: '#8e24aa', fontSize: '16px' }}>Impuestos: </label>
                        <span className='ms-2' style={{ color: '#78717A', fontSize: '15px', fontWeight: 'bold' }}>
                            <NumberFormat
                                value={parseFloat(totales.totalImpuestos) || 0}
                                displayType={'text'}
                                thousandSeparator={separacion_miles}
                                decimalSeparator={separacion_decimales}
                                prefix={`${simbolo} `}
                                decimalScale={2}
                                fixedDecimalScale
                            />
                        </span>
                    </div>

                    <div className='mt-2'>
                        <label className='ms-2' style={{ color: '#8e24aa', fontSize: '16px' }}>Total facturado: </label>
                        <span className='ms-2' style={{ color: '#78717A', fontSize: '15px', fontWeight: 'bold' }}>
                            <NumberFormat
                                value={parseFloat(totales.totalFacturado) || 0}
                                displayType={'text'}
                                thousandSeparator={separacion_miles}
                                decimalSeparator={separacion_decimales}
                                prefix={`${simbolo} `}
                                decimalScale={2}
                                fixedDecimalScale
                            />
                        </span>
                    </div>

                    <div>
                        <label className='ms-2' style={{ color: '#8e24aa', fontSize: '16px' }}>Cobrado: </label>
                        <span className='ms-2' style={{ color: '#78717A', fontSize: '15px', fontWeight: 'bold' }}>
                            <NumberFormat
                                value={parseFloat(totales.totalCobrado) || 0}
                                displayType={'text'}
                                thousandSeparator={separacion_miles}
                                decimalSeparator={separacion_decimales}
                                prefix={`${simbolo} `}
                                decimalScale={2}
                                fixedDecimalScale
                            />
                        </span>
                    </div>

                    <div>
                        <label className='ms-2' style={{ color: '#8e24aa', fontSize: '16px' }}>Por cobrar: </label>
                        <span className='ms-2' style={{ color: '#78717A', fontSize: '15px', fontWeight: 'bold' }}>
                            <NumberFormat
                                value={parseFloat(totales.totalPorCobrar) || 0}
                                displayType={'text'}
                                thousandSeparator={separacion_miles}
                                decimalSeparator={separacion_decimales}
                                prefix={`${simbolo} `}
                                decimalScale={2}
                                fixedDecimalScale
                            />
                        </span>
                    </div>

                </div>

                <InvoiceList
                    list={filteredList}
                />

            </div>
        </Dialog>
    )
}
